export default __webpack_public_path__ + "static/media/hero-bg-p.4bf1913a.jpg";